<template>
  <chat-message-wrapper :message="item" :selectable="selectable" :selected="selected" @select="$emit('select', $event)">
    <a :class="[$style.container, isOwn && $style.containerOwn]" :href="filePath" target="_blank">
      <div
        :class="$style.image"
        v-if="canView"
        ref="image"
        @click.prevent="show"
        :style="{backgroundImage: imageSource}"
        v-viewer="{movable: false}"
      >
        <img :src="filePath" alt="" style="max-width: 100%; opacity: 0">
      </div>
      <div :class="$style.file" v-else>
        <app-icon name="DownloadFile" />
      </div>

      <div :class="$style.text">{{ item.name }}</div>
    </a>
  </chat-message-wrapper>
</template>

<script>
import ChatMessageWrapper from "@/components/common/issues/main/chat/ChatMessageWrapper";
import Viewer             from 'v-viewer';
import Vue                from 'vue';
import 'viewerjs/dist/viewer.css';

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 999999999,
  },
});


const IAMGES_CAN_VIEW = [
  'jpg',
  'jpeg',
  'png',
  'gif',
];

export default {
  name:       "FileItem",
  components: { ChatMessageWrapper },
  props:      ['item', 'selectable', 'selected'],
  computed:   {
    isOwn() {
      return this.$store.getters['appUser/type'] === this.item.user.type_user;
    },
    canView() {
      let paths = this.item.name.split('.');
      return IAMGES_CAN_VIEW.includes((paths.pop()).toLowerCase());
    },
    imageSource() {
      let url = null;
      if (this.canView) {
        url = `url(${this.filePath})`;
      }
      return url;
    },
    filePath() {
      return this.$options.filters.imgPath(this.item.path);
    },
  },
  methods:    {
    show() {
      const viewer = this.$refs.image.$viewer;
      viewer.show();
    },
  },
};
</script>

<style lang="scss" module>
.container {
  display: flex;
  align-items: center;
  //margin-right: 15px;
  flex-shrink: 0;
  overflow: hidden;
  color: #fff;
}

.containerOwn {
  color: rgba(var(--app-text), 1);
}

.image {
  width: 70px;
  height: 50px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 4px;
  box-shadow: 0 10px 12px rgba(0, 0, 0, .2);
  border: 1px solid rgba(0, 0, 0, .1);
  background-color: #fff;
}


.file {
  display: flex;
  background: rgba(var(--app-primary), 1);
  color: #fff;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}


.text {
  font-weight: 500;
  line-height: 1;
  margin-left: 15px;
  overflow: hidden;
  word-wrap: break-word;
  white-space: pre-line;
}
</style>
